import type { ReactNode } from "react";

import { SelectField } from "../select-field";

export interface SelectOption {
  value: string;
  label: string;
  icon?: ReactNode;
  hint?: string;
}

interface AdminSelectMenuProps {
  value: string;
  onChange: (value: string) => void;
  options: readonly SelectOption[];
  ariaLabel?: string;
  placeholder?: string;
  className?: string;
  triggerClassName?: string;
  disabled?: boolean;
}

export function AdminSelectMenu({
  value,
  onChange,
  options,
  ariaLabel,
  placeholder,
  className = "",
  triggerClassName = "",
  disabled = false,
}: Readonly<AdminSelectMenuProps>) {
  return (
    <SelectField
      aria-label={ariaLabel}
      className={`${className} ${triggerClassName}`.trim()}
      disabled={disabled}
      onValueChange={onChange}
      options={options}
      placeholder={placeholder}
      value={value}
    />
  );
}
